















































































































































import Vue from 'vue'
import resetForm from '@morpheus/utils/admin-vue/helpers/resetForm'
import config from '../../config.json'
import BehaviorsLimitedSubForm from './BehaviorsLimitedSubForm.vue'
import BehaviorsStackableSubForm from './BehaviorsStackableSubForm.vue'
import JsonEditor from '@morpheus/utils/admin-vue/components/JsonEditor.vue'
import ItemsTable from './ItemsTable.vue'
import AppBackToListButton from '@morpheus/utils/admin-vue/components/AppBackToListButton.vue'
import { EntitlementCreateData, EntitlementTypeData } from '../types'

export default Vue.extend({
  name: 'EntitlementsForm',
  components: {
    'limited': BehaviorsLimitedSubForm,
    'stackable': BehaviorsStackableSubForm,
    JsonEditor,
    ItemsTable,
    AppBackToListButton
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    formId: {
      required: true,
      type: String
    },
    editedItem: {
      required: false,
      type: Object,
      default: () => ({})
    },
    btnLabel: {
      required: false,
      type: String,
      default: 'Submit'
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false
    },
    triggerClear: {
      required: false,
      type: Boolean,
      default: false
    },
    entitlementTypes: {
      required: true,
      type: Array as () => Array<EntitlementTypeData>
    }
  },
  data () {
    return {
      entitlement: {
        codename: '',
        max_count: 0,
        behaviors: [] as Array<any>,
        type: '',
        subtype: '',
        items: [] as any
      },
      subFormData: {},
      getDataFromSubForm: false,
      notificationMessage: '',
      editorData: {
        resources: []
      },
      isActionBtnDisabled: false,
      selectedTypeOptions: [] as any
    }
  },
  computed: {
    entitlementTypesList (): Array<any> {
      const uniqTypes: any = {}
      return this.entitlementTypes.filter(item => {
        return !uniqTypes[item.type] && (uniqTypes[item.type] = true)
      }).map((item: EntitlementTypeData) => {
        return {
          text: item.type,
          value: item.type,
          disabled: item.subtype ? false : !item.enabled,
          exclude: item.exclude ? item.exclude : []
        }
      })
    },
    behaviorsList (): any {
      return config.entitlementBehaviors.map(item => {
        return {
          text: item,
          value: item,
          disabled: !!(this.selectedTypeOptions.length && this.selectedTypeOptions[0].exclude.includes(item))
        }
      })
    },
    selectedTypesList (): Array<EntitlementTypeData> {
      return this.entitlementTypes.filter(item => {
        return item.type === this.entitlement.type
      })
    },
    entitlementSubtypesList (): Array<any> {
      const subtypesArray:Array<any> = []
      this.selectedTypesList.forEach(item => {
        if (item.hasOwnProperty('subtype')) {
          subtypesArray.push({
            text: item.subtype,
            value: item.subtype,
            disabled: !item.enabled
          })
        }
      })

      return subtypesArray
    },
    subtypeFieldRules(): string {
      return this.entitlementSubtypesList.length ? 'required' : '';
    },
    arraySubFormItems (): Array<any> {
      // FIXME
      // If you need to add subform for behavior, you should create this component,
      // import it in the current component and add behavior name to "itemsWithSubForm" array
      const itemsWithSubForm = [ 'limited', 'stackable' ]
      return itemsWithSubForm.filter(item => this.entitlement.behaviors.some(b => b.text === item))
    },
    isBehaviorsHasConsumable (): boolean {
      return this.entitlement.behaviors.some(b => b.text === 'consumable')
    }
  },
  watch: {
    triggerClear (val: boolean) {
      if (val) {
        this.clear()
      }
    }
  },
  mounted () {
    for (var prop in this.editedItem) {
      if (this.editedItem.hasOwnProperty(prop)) {
        Vue.set(this.entitlement, prop, this.editedItem[prop])
      }
    }
    if (this.editedItem.properties) {
      if (this.editedItem.properties.avatar) {
        this.editorData.resources = this.editedItem.properties.avatar.resources
      }
    }
    if (this.editedItem.hasOwnProperty('behaviors')) {
      this.selectedTypeOptions = this.entitlementTypesList.filter(type => this.editedItem.type === type.text)
      this.entitlement.behaviors = this.editedItem.behaviors.map((item:any) => {
        return {
          text: item,
          value: item,
          disabled: !!(this.selectedTypeOptions.length && this.selectedTypeOptions[0].exclude.includes(item))
        }
      })
    }
  },
  methods: {
    submit () {
      this.getDataFromSubForm = true
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            let entitlement: EntitlementCreateData = {
              codename: this.entitlement.codename,
              behaviors: this.entitlement.behaviors.map(b => b.text),
              max_count: Number(this.entitlement.max_count),
              type: this.entitlement.type,
              subtype: this.entitlement.subtype || undefined
            }
            entitlement = Object.assign(entitlement, this.subFormData)
            if (entitlement.type === 'avatar') {
              if (this.editorData.resources.length) {
                entitlement.properties = {
                  avatar: {
                    resources: this.editorData.resources
                  }
                }
              } else {
                this.subFormError("Resources array shouldn't be empty")
              }
            }
            if (this.isBehaviorsHasConsumable) {
              entitlement.items = this.entitlement.items
            }
            if (this.notificationMessage) {
              this.$store.commit('global/addNotification', { text: this.notificationMessage, type: 'error' })
              this.notificationMessage = ''
            } else {
              this.$emit('onSubmit', entitlement)
            }
          }
          this.getDataFromSubForm = false
        })
    },
    subFormError (errorMessage:string = 'Something is wrong') {
      this.notificationMessage = errorMessage
    },
    onSetBehaviorsProps (props: any) {
      this.subFormData = Object.assign(this.subFormData, props)
    },
    clear () {
      resetForm(this.entitlement)
      this.$validator.reset()
      this.$emit('onClearForm')
    },
    typeMatchingWithBehaviour (typeOptions: any) {
      if (typeOptions[0].exclude.length) {
        typeOptions[0].exclude.forEach((excludeItem: any) => {
          this.entitlement.behaviors.forEach(behavior => {
            if (behavior.text === excludeItem) {
              this.isActionBtnDisabled = true
              const message = `This type not compatible with "${behavior.text}" behavior. Please select another type or remove this behavior`
              this.$store.commit('global/addNotification', { text: message, type: 'error' })
            }
          })
        })
      }
    },
    onBehaviorsChanged () {
      this.isActionBtnDisabled = false
      if (this.entitlement.type) {
        this.typeMatchingWithBehaviour(this.selectedTypeOptions)
      }
    },
    onTypeChanged (typeOptions: any) {
      this.isActionBtnDisabled = false
      this.selectedTypeOptions = typeOptions
      this.typeMatchingWithBehaviour(typeOptions)
      this.entitlement.subtype = ''
      this.$validator.reset()

      this.checkRecommendedBehaviors()
    },
    checkRecommendedBehaviors () {
      if (this.entitlement.behaviors.length !== 0) {
        return false
      }

      if (this.entitlementSubtypesList.length) {
        if (!this.entitlement.subtype) {
          return false
        }

        const selected = this.entitlementTypes.find(item => {
          return item.subtype === this.entitlement.subtype
        })

        this.setRecommendedBehaviors(selected)
      } else {
        this.setRecommendedBehaviors(this.selectedTypesList[0])
      }
    },
    setRecommendedBehaviors (type: any) {
      if (type.hasOwnProperty('behaviors')) {
        this.$set(this.entitlement, 'behaviors', type.behaviors)
      }
    },
    addItem (items:any) {
      this.entitlement.items.push(...items)
    },
    changeItem (changedItem: any, index:number) {
      this.entitlement.items[index] = changedItem
    },
    removeItem (index: number) {
      this.entitlement.items.splice(index, 1)
    }
  }
})
